/**
 * @prettier
 */

import { CARD_TYPE } from '../constants/Cards';
import { CARD_TYPES, PRIMARY_CUSTOMIZATION_TYPES } from '../constants/CardTypes';
import { STEPS_ALLOWING_MULTIPLES } from '../constants/Steps';
import featureFlags from '../../util/featureFlags';

const cardTypesBySlug = Object.keys(CARD_TYPE).reduce((acc, typeKey) => {
  const { urlSlug } = CARD_TYPE[typeKey];
  if (urlSlug) {
    acc[urlSlug] = typeKey;
  }
  return acc;
}, {});

export const getCardTypeFromSlug = slug => (slug && cardTypesBySlug[slug]) || null;

export function getStepKey(id, cardType) {
  const needsType = STEPS_ALLOWING_MULTIPLES.includes(id) && !!cardType;

  return needsType ? `${id}-${cardType}` : id;
}

export function getStepFromPathname(pathname, orderedSteps) {
  const paths = pathname.split('/');
  const slug = paths[paths.length - 2];
  const stepId = paths[paths.length - 1];
  const cardType = getCardTypeFromSlug(slug);

  let currentStep;
  if (cardType) {
    // Find the step with matching type and id
    const stepKey = getStepKey(stepId, cardType);
    currentStep = orderedSteps.find(step => step.key === stepKey);
  } else {
    // Otherwise, find the first step with matching id
    currentStep = orderedSteps.find(step => step.id === stepId);
  }

  return currentStep;
}

// IMPORTANT: This is a hack used during sku migration to get around multiple customizations with the "ENVELOPE" type.
export function getTypeFromCustomization(customization) {
  switch (customization.type) {
    case 'DETAILS':
      return CARD_TYPES.enclosure;
    case 'ENVELOPE':
      if (/rsvp/i.test(customization.name)) {
        return CARD_TYPES.rsvpEnvelope;
      }
      return CARD_TYPES.invitationEnvelope;
    default:
      return customization.type;
  }
}

export function getBackendTypeFromType(cardType) {
  return cardType === CARD_TYPES.enclosure ? 'DETAILS' : cardType;
}

export function findLeadCustomization(allCustomizations) {
  const customizationWithLeadFlag = allCustomizations.find(c => featureFlags.get('enclosuresInInvitesFlow') && c.lead);
  const firstPrimaryCustomization = allCustomizations.find(
    c => !c.inactive && PRIMARY_CUSTOMIZATION_TYPES.includes(getTypeFromCustomization(c))
  );

  return customizationWithLeadFlag || firstPrimaryCustomization || {};
}



// WEBPACK FOOTER //
// ./src/cards/util/customization.js